import { Facebook, Instagram, Mail, MapPin, Phone } from "lucide-react";
import { BUSINESS, IMG, NAV } from "@/lib/content";
import { scrollToHash } from "@/lib/scroll";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-white/[0.06] bg-[#080B11] pb-28 pt-20 md:pb-10">
    <div className="mx-auto grid max-w-[1400px] gap-12 px-5 sm:px-8 md:grid-cols-2 lg:grid-cols-12">
      <div className="lg:col-span-4">
        <img src={IMG.mark} alt="KS Granite House LLC" className="h-20 w-auto mix-blend-lighten" />
        <p className="mt-4 font-[Cinzel] text-lg tracking-[0.16em] text-[#ECE6DA]">KS GRANITE HOUSE LLC</p>
        <p className="mt-2 text-xs uppercase tracking-[0.24em] text-[#CDA85B]">Natural beauty. Expertly crafted. Built to last.</p>
        <div className="mt-6 flex gap-3">
          <a href={BUSINESS.facebook} target="_blank" rel="noreferrer" aria-label="Facebook" data-testid="footer-facebook-link" className="grid h-10 w-10 place-items-center rounded-full border border-white/15 text-[#ECE6DA] transition-colors hover:border-[#CDA85B] hover:text-[#CDA85B]"><Facebook className="h-4 w-4" /></a>
          <a href={BUSINESS.instagram} target="_blank" rel="noreferrer" aria-label="Instagram" data-testid="footer-instagram-link" className="grid h-10 w-10 place-items-center rounded-full border border-white/15 text-[#ECE6DA] transition-colors hover:border-[#CDA85B] hover:text-[#CDA85B]"><Instagram className="h-4 w-4" /></a>
        </div>
      </div>
      <div className="lg:col-span-3">
        <h3 className="text-[11px] uppercase tracking-[0.2em] text-[#AEB3BC]">Contact</h3>
        <ul className="mt-5 space-y-4 text-sm text-[#ECE6DA]">
          <li><a href={BUSINESS.phoneHref} data-testid="footer-phone-link" className="flex gap-3 hover:text-[#CDA85B]"><Phone className="h-4 w-4 text-[#CDA85B]" />{BUSINESS.phone}</a></li>
          <li><a href={`mailto:${BUSINESS.email}`} data-testid="footer-email-link" className="flex gap-3 hover:text-[#CDA85B]"><Mail className="h-4 w-4 text-[#CDA85B]" />{BUSINESS.email}</a></li>
          <li><a href={BUSINESS.mapHref} target="_blank" rel="noreferrer" data-testid="footer-address-link" className="flex gap-3 hover:text-[#CDA85B]"><MapPin className="h-4 w-4 shrink-0 text-[#CDA85B]" />{BUSINESS.address}</a></li>
        </ul>
      </div>
      <div className="lg:col-span-3">
        <h3 className="text-[11px] uppercase tracking-[0.2em] text-[#AEB3BC]">Service area</h3>
        <p className="mt-5 text-sm leading-relaxed text-[#ECE6DA]">Kansas & Missouri<br />Kansas City, KS · Kansas City, MO<br />and the greater Kansas City metro</p>
        <p className="mt-4 text-sm text-[#C4C1B9]">BBB Accredited Business · A+ Rating</p>
      </div>
      <nav className="lg:col-span-2" aria-label="Footer">
        <h3 className="text-[11px] uppercase tracking-[0.2em] text-[#AEB3BC]">Explore</h3>
        <ul className="mt-5 space-y-2 text-sm">
          {NAV.map((n) => (
            <li key={n.href}><a href={n.href} onClick={(e) => { e.preventDefault(); scrollToHash(n.href); }} data-testid={`footer-link-${n.label.toLowerCase().replace(/\s+/g, "-")}`} className="text-[#ECE6DA] hover:text-[#CDA85B]">{n.label}</a></li>
          ))}
        </ul>
      </nav>
    </div>
    <div className="mx-auto mt-16 flex max-w-[1400px] flex-col gap-2 border-t border-white/[0.06] px-5 pt-6 text-xs text-[#AEB3BC] sm:flex-row sm:justify-between sm:px-8">
      <p>© 2026 KS Granite House LLC. All rights reserved.</p>
      <p>Custom granite, quartz, quartzite & marble countertops · Kansas City</p>
    </div>
  </footer>
);
